'use client';
import Image from '@repo/ui/src/components/Image/New';
import { ToutContent } from '@repo/ui/src/components/ToutContent';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ToutContentProps } from '@repo/ui/src/types/toutContent';
import { ImageProps } from '@repo/ui/src/types/image';
import { classNames } from '@repo/ui/src/utils/classNames';
import { appConfig } from '@repo/ui/src/utils/appConfig';

export interface RelatedGridProps {
  toutContent?: ToutContentProps;
  backgroundImage?: ImageProps;
  gridClassName?: string;
  saleText?: string;
  newText?: string;
  _data?: Array<any>; // Raw product data from CMS
  productClicked?: (product: any, index: number, listName?: string) => void;
  locale?: string;
  store?: string;
  children?: any;
}

const gradientAlignments = {
  left: 'bg-gradient-to-tl',
  right: 'bg-gradient-to-tr',
};

const RelatedGrid = ({
  toutContent,
  backgroundImage,
  gridClassName,
  children,
}: RelatedGridProps) => {
  const backgroundImageUrl = backgroundImage?.image ? buildImageSrc(backgroundImage, 400) : '';

  return (
    <div
      data-test-id={`related_product_grid_test`}
      className="grid md:grid-cols-[minmax(0,1fr),minmax(0,2fr)] lg:grid-cols-[minmax(0,1fr),minmax(0,3fr)]"
    >
      <div className={classNames('overflow-hidden', backgroundImage ? 'relative' : 'bg-black')}>
        {backgroundImage && (
          <Image
            src={backgroundImageUrl}
            alt=""
            fill
            className="z-0 absolute object-cover min-h-96"
          />
        )}
        <div
          className={classNames(
            'relative z-10 h-full min-h-[inherit] from-transparent to-[rgba(0,0,0,0.7)] to-90% from-0%',
            gradientAlignments[(toutContent?.align ?? '') as keyof typeof gradientAlignments] ??
              'bg-gradient-to-t',
          )}
        >
          <ToutContent
            dark
            headingStyleVariant="h2"
            align={toutContent?.align ?? 'left'}
            {...toutContent}
            className="p-6 sm:p-gutterLG"
            forceDivider
            fullWidthDivider={appConfig.isMeater}
          />
        </div>
      </div>
      <ul className={classNames('list-none grid grid-cols-2 lg:grid-cols-3 pl-0', gridClassName)}>
        {children}
      </ul>
    </div>
  );
};

export default RelatedGrid;
